export const demoSelector = {
    getDemoData: (state) => {
        const { demo } = state;
        const {
            demoData,
            demoCategoryData
        } = demo;

        return {
            demoData,
            demoCategoryData
        };
    },
};

export const pluginSelector = {
    getPluginData: (state) => {
        const { plugin } = state;
        const {
            installedPlugin
        } = plugin;

        return {
            installedPlugin
        };
    }
};

export const controlSelector = {
    getControlData: (state) => {
        const { control } = state;
        const {
            controlData,
        } = control;

        return {
            controlData,
        };
    },
};

export const demoAction = {
    initialDemoData: (action) => {
        return {
            type: 'INIT_DATA',
            ...action
        };
    },
    demoLike: (action) => {
        return {
            type: 'DEMO_LIKE',
            ...action
        };
    },
    demoImport: (action) => {
        return {
            type: 'DEMO_IMPORT',
            ...action
        };
    },
    demoCategories: (action) => {
        return {
            type: 'DEMO_CATEGORIES',
            ...action
        }
    }
};

export const pluginAction = {
    initialPluginData: (action) => {
        return {
            type: 'INIT_PLUGIN_DATA',
            ...action
        };
    },
    installPlugin: (action) => {
        const { slug, name, path, version } = action;
        return {
            type: 'INSTALL_PLUGIN',
            slug,
            name,
            path,
            version
        };
    },
    updatePlugin: (slug, version) => {
        return {
            type: 'UPDATE_PLUGIN',
            slug,
            version
        };
    },
    activatePlugin: (slug) => {
        return {
            type: 'ACTIVATE_PLUGIN',
            slug
        };
    },
};

export const demoReducer = (state = {}, action) => {
    switch (action.type) {
        case 'INIT_DATA':
            const {
                demoData,
            } = action;

            return {
                ...state,
                demoData,
            };
        case 'DEMO_LIKE':
            return {
                ...state,
                demoData: state.demoData.map(demo => {
                    if (action.slug === demo.data.slug) {
                        return {
                            ...demo,
                            like: action.flag
                        };
                    }

                    return demo;
                })
            };
        case 'DEMO_IMPORT':
            return {
                ...state,
                demoData: state.demoData.map(demo => {
                    if (action.slug === demo.data.slug) {
                        return {
                            ...demo,
                            imported: action.flag
                        };
                    }

                    return demo;
                })
            };
        case 'DEMO_CATEGORIES':
            const {
                demoCategoryData,
            } = action;
            return {
                ...state,
                demoCategoryData: demoCategoryData
            };
        default:
            return state;
    }
};

export const pluginReducer = (state = {}, action) => {
    switch (action.type) {
        case 'INIT_PLUGIN_DATA':
            const {
                installedPlugin
            } = action;

            return {
                installedPlugin
            };
        case 'INSTALL_PLUGIN':
            return {
                installedPlugin: {
                    ...state.installedPlugin,
                    [action.slug]: {
                        name: action.name,
                        version: action.version,
                        path: action.path,
                        active: true,
                    },
                }
            };
        case 'UPDATE_PLUGIN':
            return {
                installedPlugin: {
                    ...state.installedPlugin,
                    [action.slug]: {
                        ...state.installedPlugin[action.slug],
                        active: true,
                        version: action.version,
                    }
                },
            };
        case 'ACTIVATE_PLUGIN':
            return {
                installedPlugin: {
                    ...state.installedPlugin,
                    [action.slug]: {
                        ...state.installedPlugin[action.slug],
                        active: true,
                    }
                },
            };
        default:
            return state;
    }
};

export const controlReducer = (state = {}, action) => {
    switch (action.type) {
        case 'INIT_CONTROL_DATA':
            const {
                controlData
            } = action;
            return {
                controlData
            };
        case 'SET_CONTROL_DATA':
            window.essential_setting_change = action.action.option;
            return {
                ...state,
                controlData: {
                    ...state.controlData,
                    [action.action.option]: action.action.value
                },
            };
        default:
            return state;
    }
};

export const controlAction = {
    initialControlData: (action) => {
        return {
            type: 'INIT_CONTROL_DATA',
            ...action
        };
    },
    setControlData: (action) => {
        return {
            type: 'SET_CONTROL_DATA',
            action
        };
    },
};

export const dashboardAction = {
    initialModalData: (action) => {
        return {
            type: 'INIT_MODAL_DATA',
            ...action
        };
    },
    setKeyword: (keyword) => {
        return {
            type: 'SET_KEYWORD',
            keyword
        };
    },
    setPaging: (paging) => {
        return {
            type: 'SET_PAGING',
            paging
        };
    },
    setLike: (like) => {
        return {
            type: 'SET_LIKE',
            like
        };
    },
    setImported: (imported) => {
        return {
            type: 'SET_IMPORTED',
            imported
        };
    },
    setLockDemoImport: (demo) => {
        return {
            type: 'SET_DEMO_IMPORT',
            demo
        };
    },
    setDemoProgress: (text) => {
        return {
            type: 'SET_DEMO_PROGRESS',
            text
        };
    },
};

export const dashboardReducer = (state = {}, action) => {
    switch (action.type) {
        case 'INIT_MODAL_DATA':
            const {
                demoContentData
            } = action;

            return {
                demoContentData
            };
        case 'SET_KEYWORD':
            return {
                ...state,
                demoContentData: {
                    ...state.demoContentData,
                    keyword: action.keyword
                }
            };
        case 'SET_PAGING':
            return {
                ...state,
                demoContentData: {
                    ...state.demoContentData,
                    paging: action.paging
                }
            };
        case 'SET_LIKE':
            return {
                ...state,
                demoContentData: {
                    ...state.demoContentData,
                    like: action.like
                }
            };
        case 'SET_IMPORTED':
            return {
                ...state,
                demoContentData: {
                    ...state.demoContentData,
                    imported: action.imported
                }
            };
        case 'SET_DEMO_IMPORT':
            return {
                ...state,
                lockDemoImport: action.demo
            };
        case 'SET_DEMO_PROGRESS':
            return {
                ...state,
                demoProgress: action.text
            };
        default:
            return state;
    }
};

export const dashboardSelector = {
    getDashboardData: (state) => {
        const { modal } = state;
        const {
            demoContentData,
        } = modal;

        return {
            demoContentData,
        };
    },
};

export const templateAction = {
    initialTemplate: (action) => {
        return {
            type: 'INIT_TEMPLATE_DATA',
            ...action
        };
    },
    setTemplate: (action) => {
        return {
            type: 'SET_TEMPLATE_DATA',
            action
        };
    },
    addTemplate(template, key) {
        return {
            type: 'ADD_TEMPLATE',
            template,
            key
        };
    },
};


export const templateSelector = {
    getTemplateData: (state) => {
        return state.template;
    },
};

export const templateReducer = (state = {}, action) => {
    switch (action.type) {
        case 'INIT_TEMPLATE_DATA':
            const {
                template
            } = action;
            return {
                ...template
            };
        case 'SET_TEMPLATE_DATA':
            return {
                ...state,
                [action.action.key]: action.action.value
            };
        case 'ADD_TEMPLATE':
            return {
                ...state,
                temlateData: {
                    ...state.temlateData,
                    [action.key]: [...state.temlateData[action.key], action.data]
                }
            };
        default:
            return state;
    }
};